import { createTheme } from '@mui/material/styles';

// A shared type scale for the admin workspace, including portalled drawers,
// dialogs and menus. Keep the current register's palette and branding intact.
export function createAdminTheme(baseTheme) {
  const body = { fontSize: '0.875rem', lineHeight: 1.5, fontWeight: 400, letterSpacing: 'normal' };
  const secondary = { ...body, fontSize: '0.75rem' };
  const heading = { ...body, fontSize: '1.125rem', fontWeight: 600 };
  return createTheme(baseTheme, {
    typography: {
      fontFamily: "'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      fontWeightRegular: 400,
      fontWeightMedium: 500,
      fontWeightBold: 600,
      body1: body,
      body2: body,
      caption: secondary,
      overline: { ...secondary, fontWeight: 600, letterSpacing: '0.04em' },
      subtitle1: { ...body, fontWeight: 600 },
      subtitle2: { ...body, fontWeight: 600 },
      button: { ...body, fontWeight: 500, textTransform: 'none' },
      h1: heading, h2: heading, h3: heading, h4: heading, h5: heading, h6: heading,
    },
    components: {
      MuiButton: { styleOverrides: { root: { ...body, fontWeight: 500 } } },
      MuiInputBase: { styleOverrides: { root: body } },
      MuiInputLabel: { styleOverrides: { root: body } },
      MuiMenuItem: { styleOverrides: { root: body } },
      MuiFormLabel: { styleOverrides: { root: body } },
      MuiFormHelperText: { styleOverrides: { root: secondary } },
      MuiChip: { styleOverrides: { root: { ...secondary, fontWeight: 500 } } },
      MuiDialogTitle: { styleOverrides: { root: heading } },
      MuiTableCell: { styleOverrides: {
        root: { ...body, padding: '18px 20px', borderBottom: '1px solid #e8edf3' },
        sizeSmall: { padding: '16px 20px' },
        head: { padding: '16px 20px', backgroundColor: '#f8fafc', color: '#526176', fontWeight: 600, whiteSpace: 'nowrap' },
      } },
      MuiTableRow: { styleOverrides: { root: {
        '&:last-child td': { borderBottom: 0 },
        '&.MuiTableRow-hover:hover': { backgroundColor: '#f4f7fb' },
      } } },
      MuiDataGrid: {
        defaultProps: { rowHeight: 64, columnHeaderHeight: 56 },
        styleOverrides: { root: {
          ...body,
          borderColor: '#e0e6ed',
          borderRadius: 12,
          backgroundColor: '#fff',
          '& .MuiDataGrid-cell': { display: 'flex', alignItems: 'center', padding: '0 16px', borderBottom: '1px solid #e8edf3', lineHeight: 1.5 },
          '& .MuiDataGrid-columnHeader': { padding: '0 16px', backgroundColor: '#f8fafc', color: '#526176' },
          '& .MuiDataGrid-columnHeaderTitle': { fontSize: '0.875rem', fontWeight: 600 },
          '& .MuiDataGrid-row:hover': { backgroundColor: '#f4f7fb' },
          '& .MuiDataGrid-toolbarContainer': { flexShrink: 0, padding: '12px 16px', gap: 8, borderBottom: '1px solid #e8edf3' },
          '& .MuiDataGrid-toolbarContainer .MuiButton-root': { fontSize: '0.875rem', fontWeight: 500 },
          '& .MuiDataGrid-footerContainer': { minHeight: 60, borderTop: '1px solid #e8edf3', backgroundColor: '#fbfcfe' },
          '& .MuiDataGrid-cell .MuiChip-root': { height: 28, borderRadius: 8 },
          '& .MuiDataGrid-cell .MuiIconButton-root': { padding: 7, borderRadius: 8 },
        } },
      },
    },
  });
}
